import {
    GET_ALL_USERS,
    GET_ALL_UNAPPROVED_USERS,
    APPROVE_USER,
    ADD_USER,
    DELETE_USER,
    GET_ALL_USER_ACTIVITY,
    GET_USER_ACTIVITY,
    EDIT_USER,
    DELETE_USER_ACTIVITY,

    ADD_PARTICIPANT,
    SAVE_FORMDATA,
    CLEAR_FORMDATA
} from '../actions/UserActions'

import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'user',
    storage,
};


const initialState = {
    formData: { name: "", lastName: "", email: "", mobileNumber: "" },
    participant: null,
    token: null,
    isLoggedin: false,
}

const UserReducer = function (state = initialState, action) {
    switch (action.type) {
        case SAVE_FORMDATA: {
            return {
                ...state,
                formData: action.payload,
            }
        }
        case CLEAR_FORMDATA: {
            return {
                ...state,
                formData: { name: "", lastName: "", email: "", mobileNumber: "" },
            }
        }
        case ADD_PARTICIPANT: {
            return {
                ...state,
                participant: action.payload.data,
                token: action.payload.meta.access
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}


export default persistReducer(persistConfig, UserReducer);
